import React, { useRef } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Navbar from "./components/navbar";
import Contact from "./sections/contact";
import About from "./sections/about";
import Home from "./sections/home";
import Cubas from "./sections/cubas";
import Piezas from "./sections/piezas";
import Bodegas from "./sections/bodegas";
import { TEXTS } from "./static/texts";
import { ICONS } from "./static/assets/icons/icons";

const pageTop = document.getElementById("root");

const menuItems = [
  {
    isIcon: false,
    text: TEXTS.SECTION_SERVICES,
    // scrollToSection: true,
    to: "/",
  },
  {
    isIcon: false,
    text: TEXTS.SECTION_ABOUT_US,
    to: "/nosotros",
  },
  {
    isIcon: false,
    text: TEXTS.SECTION_CONTACT,
    scrollToSection: true,
  },
  {
    isIcon: true,
    image: ICONS.INSTAGRAM,
    alt: "Instagram",
    href: "https://www.instagram.com/concretvs/",
  },
  {
    isIcon: true,
    image: ICONS.WHATSAPP,
    alt: "Whatsapp",
    href: "https://api.whatsapp.com/send?phone=541149986500",
  },
  {
    isIcon: true,
    image: ICONS.EMAIL,
    alt: "Email",
    href: "mailto:info@concretvs.com",
  },
];

const App = () => {
  const contactRef = useRef(null);

  const sectionRefs = {
    [TEXTS.SECTION_CONTACT]: contactRef,
  };

  return (
    <Router>
      <Navbar
        pageTop={pageTop}
        menuItems={menuItems}
        sectionRefs={sectionRefs}
      />
      <Switch>
        <Route path="/nosotros">
          <About pageTop={pageTop} />
        </Route>
        <Route path="/cubas-lagares">
          <Cubas pageTop={pageTop} />
        </Route>
        <Route path="/piezas-especiales">
          <Piezas pageTop={pageTop} />
        </Route>
        <Route path="/bodegas-vinificadoras">
          <Bodegas pageTop={pageTop} />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <Contact pageTop={pageTop} sectionRef={contactRef} />
    </Router>
  );
};

export default App;
